'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userInfo;

var _immutable = require('immutable');

var _UserInfoActionTypes = require('../actionTypes/UserInfoActionTypes');

var initialState = new _immutable.Map({
  firstName: null,
  lastName: null,
  companyName: null,
  companySize: null,
  jobField: null,
  jobRole: null,
  clientEmail: null,
  clientCompanyName: null,
  clientFirstName: null,
  clientLastName: null,
  email: null,
  domain: null,
  password: null,
  languages: null,
  legalBasisForContact: null,
  partnerPortalId: null,
  isFromContext: false
});

function userInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _UserInfoActionTypes.STORE_USERDATA:
      return state.merge(payload);
    default:
      return state;
  }
}
module.exports = exports['default'];